import { useEffect, useState } from "react";
import { ReactComponent as ChevronLeft } from "../../Assets/angle-left-solid.svg";
import { ReactComponent as XIcon } from "../../Assets/x-mark.svg";
import ContentRenderer from "../../Components/ContentRenderer/ContentRenderer";
import IconButton from "../../Components/IconButton/IconButton";
import InlineHtml from "../../Components/InlineHtml/InlineHtml";
import { closeWidgetAndReset } from "../../Components/WidgetHeader/WidgetHeader";
import {
  fetchView,
  SingleContentResponse,
} from "../../Helper/CustomWidgetsClient";
import { useConfigStore } from "../../Stores/Config";
import { useRouterStore } from "../../Stores/Router";
import "./CustomView.scss";

function CustomView() {
  const routerStore = useRouterStore();
  const configStore = useConfigStore();
  const showBackButton = routerStore.showBackButton;
  const viewName = routerStore.currentData?.viewName ?? "";
  const payload = routerStore.currentData?.payload ?? null;
  const [response, setResponse] = useState<SingleContentResponse>({});
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!viewName) {
      setFailed(true);
      setLoaded(true);
      return;
    }
    let cancelled = false;
    setFailed(false);
    setLoaded(false);
    setResponse({});
    fetchView(viewName, payload)
      .then((res) => {
        if (cancelled) return;
        setResponse(res);
        setLoaded(true);
      })
      .catch(() => {
        if (cancelled) return;
        setFailed(true);
        setLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, [viewName, payload]);

  const html = response.html;
  const content = response.content ?? [];
  const isEmpty = !html && content.length === 0;

  return (
    <div className="custom-view">
      {showBackButton && (
        <div className="back-button">
          <IconButton
            icon={ChevronLeft}
            ariaLabel={configStore.translateTextWithFallback("back", "Back")}
            onClick={() => {
              routerStore.popPage();
            }}
          />
        </div>
      )}
      <IconButton
        className="close-button"
        icon={XIcon}
        ariaLabel={configStore.translateTextWithFallback("close", "Close")}
        onClick={() => {
          closeWidgetAndReset();
        }}
      />
      <div className="custom-view-body">
        {!loaded && (
          <div className="custom-view-loading">
            <div className="skeleton-box custom-view-skeleton" />
            <div className="skeleton-box custom-view-skeleton custom-view-skeleton--short" />
            <div className="skeleton-box custom-view-skeleton" />
          </div>
        )}
        {loaded && (failed || isEmpty) && (
          <div className="custom-view-empty">
            {configStore.translateText("viewNotAvailable") ||
              "View not available"}
          </div>
        )}
        {loaded && !failed && html && (
          <InlineHtml html={html} className="custom-view-html" />
        )}
        {loaded && !failed && !html && content.length > 0 && (
          <ContentRenderer items={content} />
        )}
      </div>
    </div>
  );
}

export default CustomView;
